import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { ProfileUpdateResponse } from '../interface/profile.i';

/*
  This class represents the current "state" of Profile.
  This can be enhanced to include indicators of how much the user has populated the Profile.
*/
@Injectable({
  providedIn: 'root'
})
export class ProfileStoreService {
  $currentWorkingProfile: Observable<ProfileUpdateResponse>;
  private _currentWorkingProfile: ProfileUpdateResponse;
  private currentWorkingProfileSubject = new BehaviorSubject<ProfileUpdateResponse>(undefined);
  constructor() {
    this.initParams();
  }

  updateProfileData(value: ProfileUpdateResponse) {
    const updatedProfile = { ...this._currentWorkingProfile, ...value };
    this._currentWorkingProfile = updatedProfile;
  }
  private initParams() {
    this.$currentWorkingProfile = this.currentWorkingProfileSubject.asObservable();
  }

  /*
    Use this getter to access the Current Working Profile object. This is useful in Edit flow.
    In the component where you are handling the Profile edit flow, inject this service (ProfileStoreService) via DI.
    Then, in ngOnInit, initualize the local profile object to the Profile object obtained from this geter, something like so:

    this.currentProfile = this.profileStoreService.currentWorkingProfile;

    You will then get access to the current state of profile. You must then compare the profile state
    with Asset Library response, and identify which content groups are already part of the Profile.
  */
  get currentWorkingProfile(): ProfileUpdateResponse {
    return this._currentWorkingProfile;
  }

  /*
    In the component where you make the PATCH call, inject this service (ProfileStoreService) via DI.
    When you make the PATCH call and get the response, cast the response to the type ProfileUpdateResponse.
    Then, call the below setter to update the Profile Store, like so:

    this.profileStoreService.currentWorkingProfile = <response from PATCH API>;
  */
  set currentWorkingProfile(value: ProfileUpdateResponse) {
    this._currentWorkingProfile = value;
    this.currentWorkingProfileSubject.next(this._currentWorkingProfile);
  }
}
